/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';
import type { LabelProps } from './types';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function Label( { text }: LabelProps ): ReactNode {
	const { palette } = useTheme();

	return (
		<Box
			sx={ {
				height: '22px',
				padding: '1px 8px',
				borderRadius: '4px',
				backgroundColor: palette.info[ 100 ]
			} }
		>
			<Typography
				fontWeight={ 400 }
				fontSize={ '12px' }
				lineHeight={ '20px' }
				color={ palette.info[ 600 ] }
			>
				{ text }
			</Typography>
		</Box>
	);
}
